<template>
    <div>
        <heading>
            {{ $t("instructions.folder.title") }}
        </heading>

        <instructionFolderTable />
    </div>
</template>

<script>
import instructionFolderTable from "@/views/instructions/instructionFolderTable.vue";
export default {
    name: "instructionFolder",
    components: { instructionFolderTable },
};
</script>
